// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_2WPAS","listWrap":"index_listWrap_Qm0Y1"};